import React, { useEffect, useState } from "react";
import {
  AddFlex,
  CustomInput,
  CustomInputArea,
  CustomInputLabel,
  CustomText,
  Gap,
  PrimaryActionButton,
} from "../Components/reusableStyles";
import { callNonStoreApi, isNullOrUndefined } from "../utils/utils";
import { AddNewHelpVideo, UpdateHelpVideo } from "../utils/ApiEndpoints";
import { Close } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";

function HelpAndSupportDialogComponent({
  video,
  setForceRefresh,
  closeDialog,
  tag,
}) {
  const [videoData, setVideoData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleUpdateVideoData = (key, value) => {
    setVideoData((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const handleUpdateVideo = async () => {
    setLoading(true);
    if (isNullOrUndefined(video)) {
      const response = await callNonStoreApi(AddNewHelpVideo, videoData);
    } else {
      const response = await callNonStoreApi(UpdateHelpVideo, videoData);
    }
    setForceRefresh((prev) => !prev);
    setLoading(false);
    closeDialog();
  };

  useEffect(() => {
    setVideoData(video ? video : { tag });
    return () => {
      setVideoData({});
    };
  }, []);

  return (
    <AddFlex flexDirection="column" gap="20px" height="100%">
      <AddFlex>
        <CustomText color="black">
          {isNullOrUndefined(video)
            ? "Add New Help Video"
            : "Update Help Video"}
        </CustomText>
        <Gap />
        <Close
          onClick={() => {
            closeDialog();
            setVideoData({});
          }}
        />
      </AddFlex>
      <CustomInput
        value={videoData.name}
        label={"Add video name"}
        onChange={(text) => {
          handleUpdateVideoData("name", text);
        }}
      />
      <AddFlex flexDirection="column">
        <CustomInputLabel>Add video description</CustomInputLabel>
        <CustomInputArea
          value={videoData.description}
          onChange={(e) => {
            handleUpdateVideoData("description", e.target.value);
          }}
        />
      </AddFlex>
      <CustomInput
        value={videoData.url}
        label={"Add video url"}
        onChange={(text) => {
          handleUpdateVideoData("url", text);
        }}
      />
      <Gap />
      <PrimaryActionButton
        onClick={handleUpdateVideo}
        style={{ height: "44px" }}
      >
        {loading ? (
          <CircularProgress size={14} sx={{ color: "white" }} />
        ) : isNullOrUndefined(video) ? (
          "Add Video"
        ) : (
          "Update Video"
        )}
      </PrimaryActionButton>
    </AddFlex>
  );
}

export default HelpAndSupportDialogComponent;
